import React from 'react';
import PropTypes from 'prop-types';

import './PrintHeader.css';

const PrintHeader = props => (
  <div className='PrintHeader'>
    <h2>{props.title}</h2>
  </div>
);

PrintHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default PrintHeader;



// WEBPACK FOOTER //
// ./src/components/presentation/Print/PrintHeader.js